export const dbTabs1 = {
  presentation: {
    descriptionTitle: "Opis oferty",
    descriptionSub: "Wybór, czy opis ma być widoczny na stronie rezerwacji bezpośrednich dla każdej jednostki.",
    visible: "Widoczny",
    hidden: "Ukryty",
    amenitiesTitle: "Usługi w cenie",
    amenitiesSub: "Określenie, które usługi i udogodnienia są pokazywane dla każdej jednostki w silniku rezerwacji.",
    amenitiesCount: "{count} usługa | {count} usługi | {count} usług",
    editAmenitiesTitle: "Edytuj usługi",
    edit: "Edytuj",
    imagesTitle: "Zdjęcia obiektu",
    imagesSubtitle: "Dodawanie, zmiana kolejności i wybór zdjęcia głównego każdej jednostki, które pojawi się w silniku rezerwacji.",
  },
  reservations: {
    updating: "Aktualizowanie…",
    engineActive: "Silnik aktywny",
    engineInactive: "Silnik nieaktywny",
    engineActiveDesc: "Goście mogą rezerwować pokoje bezpośrednio z linku.",
    engineInactiveDesc: "Rezerwacje bezpośrednie są wyłączone dla tego hotelu.",
    statusActive: "Aktywny",
    statusInactive: "Nieaktywny",
    roomsAvailable: "Dostępne pokoje",
    colRoom: "Pokój",
    colCap: "Poj.",
    colActive: "Aktywny",
    noRooms: "Nie skonfigurowano żadnych pokoi.",
    hotelLabel: "Hotel",
    unitActive: "Aktywna",
    unitInactive: "Nieaktywna",
    enableNotice: "Aby zarządzać pokojami, należy włączyć rezerwacje bezpośrednie.",
    toastUpdated: "Zaktualizowano.",
    toastUpdateError: "Nie udało się zaktualizować.",
    toastGlobalUpdated: "Status globalny został zaktualizowany.",
  },
  promotions: {
    title: "Promocje w rezerwacji bezpośredniej",
    subtitle: "Kontrola nad tym, które promocje są aktywne, czy można je łączyć i w jakiej kolejności.",
    loading: "Wczytywanie promocji…",
    empty: "Brak promocji skonfigurowanych dla tego obiektu.",
    dragTitle: "Przeciągnij, aby zmienić kolejność",
    switchTitle: "Aktywna w rezerwacji bezpośredniej",
    badgeLabel: "Etykieta",
    badgePlaceholder: "np. -10% / Okazja",
    stackableLabel: "Łączona",
    tip: "Wskazówka: włączenie promocji powoduje jej zastosowanie w rezerwacji bezpośredniej, a opcja „Łączona” pozwala łączyć ją z innymi promocjami.",
    toastLoadError: "Nie udało się wczytać promocji.",
    toastSaved: "Promocje zostały zapisane.",
    toastSaveError: "Nie udało się zapisać promocji.",
    dateFrom: "Od {date}",
    dateUntil: "Do {date}",
  },
  addons: {
    title: "Obłożenie i dopłaty",
    hint1: "Jedna korekta na {scope}: obniżka przy mniejszej liczbie gości",
    hintOr: "lub",
    hint2: "dopłata za każdego dodatkowego gościa. Nie oba naraz.",
    perRoom: "pokój",
    perAccommodation: "obiekt",
    loading: "Wczytywanie konfiguracji…",
    emptyHotel: "Ten hotel nie ma skonfigurowanych pokoi.",
    thisAccommodation: "Ten obiekt",
    modeReduction: "Obniżka",
    modeSurcharge: "Dopłata",
    modeNone: "Bez korekty",
    toastLoadError: "Nie udało się wczytać konfiguracji obłożenia.",
    toastSaved: "Obłożenie zostało zapisane.",
    toastSaveError: "Nie udało się zapisać obłożenia.",
  },
};
